import {
    DialogBody,
    DialogCloseTrigger,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogRoot,
} from "@agrigate/shared-web-ui/lib/components/ui/dialog";
import { Button, Flex } from "@chakra-ui/react";
import type { ReactElement } from "react";
import { useForm } from "react-hook-form";
import FormInput from "./FormInput";

interface SwitchUserModalProps {
    isModalOpen: boolean;
    closeModal: () => void;
    handleSwitchUser: (userId: string) => Promise<void>;
}

const SwitchUserModal = (p: SwitchUserModalProps): ReactElement => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm<{ userId: string }>({
        defaultValues: {
            userId: "",
        },
    });

    const onSubmit = async (data: { userId: string }) => {
        await p.handleSwitchUser(data.userId);
        reset();
        p.closeModal();
    };

    return (
        <DialogRoot
            open={p.isModalOpen}
            onOpenChange={p.closeModal}
            placement={"center"}
        >
            <DialogContent>
                <DialogHeader>Switch User</DialogHeader>
                <DialogBody>
                    <FormInput
                        label="User Id"
                        id={"userId"}
                        errorType={errors?.userId?.type}
                        required
                        register={register}
                        formLabelProps={{
                            color: "gray.500",
                            fontWeight: 500,
                            fontSize: "xs",
                        }}
                        inputProps={{
                            placeholder: "Enter user id here",
                        }}
                    />
                </DialogBody>
                <DialogFooter bgColor={"gray.25"}>
                    <Flex gap={3}>
                        <Button
                            variant={"outline"}
                            onClick={p.closeModal}
                            bgColor={"gray.150"}
                        >
                            Cancel
                        </Button>
                        <Button
                            bgColor={"blue.500"}
                            color={"white"}
                            onClick={handleSubmit(onSubmit)}
                        >
                            Switch
                        </Button>
                    </Flex>
                </DialogFooter>
                <DialogCloseTrigger />
            </DialogContent>
        </DialogRoot>
    );
};

export default SwitchUserModal;
